import { ArtistModel } from 'models';
import MetricCard from '../../Index/MetricCard/MetricCard';

export interface ArtistMetricCardProps {
	artist: ArtistModel;
	metric: number;
	priorMetricValue?: number;
	onClick?: () => void;
	onArtistTextClick?: () => void;
	avatarSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
	titleSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
	showLabel?: boolean;
	buttonText?: string;
	buttonIcon?: JSX.Element;
	onButtonClick?: () => void;
	buttonLoading?: boolean;
	showBorder?: boolean;
	disabled?: boolean;
	customLabel?: string;
}

export default function ArtistMetricCard({ artist, metric, priorMetricValue, onClick, onArtistTextClick, avatarSize = 'sm', titleSize = 'md', showLabel = true, showBorder = true, disabled = false, customLabel = '' }: ArtistMetricCardProps) {
	const name = customLabel || artist.name;
	const image = artist.image;

	return (
		<MetricCard
			name={name}
			image={image}
			metric={metric}
			priorMetricValue={priorMetricValue}
			onClick={onClick}
			onNameTextClick={onArtistTextClick}
			avatarSize={avatarSize}
			titleSize={titleSize}
			showLabel={showLabel}
			showBorder={showBorder}
			disabled={disabled}
		/>
	);
}
